import { createSelector } from 'reselect';
import { getHomeSpacesForView } from '@app/selectors/home';

export const getHomeRecentSpaces = createSelector(
  [
    getHomeSpacesForView,
    (state: any) => state.spaceSelector?.recentlyViewedSpaces?.spaceList || [],
  ],
  (spacesForView, recentSpaceList) => {
    const spacesForViewMap = new Map(
      (spacesForView || []).map((s) => [s.objectId || (s as any).id, s])
    );

    return recentSpaceList
      .filter(
        (recentSpace: any) =>
          recentSpace.isStaffAccess || spacesForViewMap.has(recentSpace.spaceId)
      )
      .map((recentSpace: any) => {
        const space = spacesForViewMap.get(recentSpace.spaceId);

        if (!space) {
          return {
            id: recentSpace.spaceId,
            objectId: recentSpace.spaceId,
            name: recentSpace.name,
            avatar: recentSpace.avatar,
            isStarred: !!recentSpace.isStarred,
            lastNavigation: recentSpace.lastNavigation,
            isStaffAccess: true,
          };
        }

        return {
          ...space,
          isStarred: !!space.isStarred,
          lastNavigation: recentSpace.lastNavigation,
          isStaffAccess: !!recentSpace.isStaffAccess,
        };
      });
  }
);
